module.exports = __webpack_public_path__ + "img/almost-there-bg.c8253224.png";